import { render } from "./radiobutton-vertical.html?vue&type=template&id=4f303e3c&scoped=true&ts=true&external"
import script from "./radiobutton-vertical.ts?vue&type=script&lang=ts&external"
export * from "./radiobutton-vertical.ts?vue&type=script&lang=ts&external"

import "./radiobutton-vertical.scss?vue&type=style&index=0&id=4f303e3c&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f303e3c"]])

export default __exports__